export default "__VITE_ASSET__4ab785b5__"